import axios from "axios";
import { ApiResponse } from "@interface/common";
import {
  CountryItem,
  SensorStatisticsData,
  SensorStatisticsSearchConditions,
  SensorStatisticsSearchParam,
} from "@interface/sensor/SensorStatistics";

export const getSensorStatistics = async (param: SensorStatisticsSearchParam) => {
  const { data } = await axios.get<ApiResponse<CountryItem[]>>(
    "/api/sensor-statistics/ntnl-list",
      { params: param }
  );
  return data;
};

export const getSensorStatisticsSearchConditions = async () => {
  const { data } = await axios.get<
    ApiResponse<SensorStatisticsSearchConditions>
  >("/api/sensor-statistics/search-conditions");
  return data;
};

export const getSensorStatisticsData = async (
  param: SensorStatisticsSearchParam
) => {
  const { data } = await axios.get<ApiResponse<SensorStatisticsData>>(
    "/api/sensor-statistics/search-data",
    { params: param }
  );
  return data;
};
